import { Pipe, type PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, type SafeValue } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize',
})
export class SanitizePipe implements PipeTransform {
    public constructor(private readonly sanitizer: DomSanitizer) {}

    public transform(value: string, context: SecurityContext): SafeValue {
        switch (context) {
            case SecurityContext.RESOURCE_URL:
                // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            case SecurityContext.HTML:
                // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
                return this.sanitizer.bypassSecurityTrustHtml(value);
            default:
                throw new Error(`Not supported SecurityContext '${context}'`);
        }
    }
}
